import React from "react";
import { images } from "../Data";

const CategoryCard = ({ title, image }) => {
  return (
    <div className="flex link flex-col gap-4 text-sm text-nowrap text-center">
      <div>
        <object
          data={image}
          type="image/jpeg"
          className="w-full object-cover h-full"
        >
          <img
            src={images.fallbackimg1}
            alt={title}
            className="w-full object-cover h-full"
          />
        </object>
      </div>
      <div>{title}</div>
    </div>
  );
};

export default CategoryCard;
